import { minMaxChanged } from "../../actions/filters";
import makeGroupedMultiSelect from "../../../../shared/make_grouped_multi_select";

const valuesSelector = (state) => state.filters.minMax.selectedValues;
const optionsSelector = (state) => state.filters.minMax.options;

export default makeGroupedMultiSelect(minMaxChanged, "Min or Max", valuesSelector, optionsSelector, { clearable: true, placeholder: "Filter by type of limit" }, { "col-md-3": true });
